import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
/**
 * Portals provide a first-class way to render children into a DOM node that exists outside the DOM hierarchy of the parent component.
 *
 * @see https://reactjs.org/docs/portals.html
 */

var Portal = function Portal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? "div" : _ref$tag,
      renderInContainer = _ref.renderInContainer;

  var _useState = useState(function () {
    var el = document.createElement(tag);
    className && el.classList.add(className);
    return el;
  }),
      _useState2 = _slicedToArray(_useState, 1),
      renderIn = _useState2[0]; // Append container to `body`


  useEffect(function () {
    document.body.appendChild(renderIn);
    return function () {
      document.body.removeChild(renderIn);
    };
  }, []);
  return /*#__PURE__*/createPortal(children, renderInContainer || renderIn);
};

export { Portal };